import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { Logger } from '@core/services/logger.service';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';

@Pipe({
	name: 'publicOrSecureImageLoader'
})
export class PublicOrSecureImageLoaderPipe implements PipeTransform {

	private readonly COMPONENT_NAME = "PublicOrSecureImageLoaderPipe";

	constructor (
		private _httpClient: HttpClient,
		private _logger: Logger) { }

	transform(src: string | undefined, fallbackSrc: string | undefined, ...args: unknown[]): Observable<string> {
		if (src) {
			return of(src);
		}
		else if (fallbackSrc) {
			return this.getImage(fallbackSrc).pipe(
				catchError(() => of('assets/images/material-not-found-thumbnail.png'))
			);
		}
		else {
			// TBD: report error
			this._logger.error(this.COMPONENT_NAME, "Both src and fallback urls are empty.");
			return of('assets/images/material-not-found-thumbnail.png');
		}
	}

	private getImage(url: string | undefined): Observable<string> {
		return this._httpClient.get(url ?? '', { responseType: 'blob' }).pipe(
			switchMap(blob => this.readFile(blob)),
			catchError(error => {
				return throwError(() => 'assets/images/material-not-found-thumbnail.png');
			})
		);
	}

	private readFile(blob: Blob): Observable<string> {
		return new Observable<string>((observer) => {
			const reader = new FileReader();
			reader.onloadend = () => {
				if (reader.result) {
					observer.next(reader.result as string);
					observer.complete();
				}
				else {
					observer.error('Failed to load image from the backend');
				}
			};
			reader.onerror = (error) => observer.error(error);
			reader.readAsDataURL(blob);
		});
	}
}
